import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ExternalLink, Calendar, Globe } from "lucide-react";
import moment from "moment";

interface Article {
  //id: number;
  title: string;
  publication: string;
  date: string;
  excerpt: string;
  url?: string;
  author?: string;
}

export default function JournalistArticles({ article }) {
  const [selectedArticle, setSelectedArticle] = useState<number | null>(null);

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300 border border-musicGrey/20">
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex-1">
            <div className="flex items-center gap-4 mb-2 text-sm " style={{color: "white"}}>
              <div className="flex items-center gap-1">
                <Globe size={16} />
                <span className="font-medium">{article.website_name}</span>
              </div>
              <div className="flex items-center gap-1">
                <Calendar size={16} />
                <span>{moment(article.publish_date).format("MMMM DD, YYYY")}</span>
              </div>
              {/*article.author && <span>by {article.author}</span>*/}
            </div>

            <h3 className="text-xl font-bold text-musicBlack mb-3 hover:text-musicRed transition-colors">
              {article.title}
            </h3>

            <p className="text-musicBlack/80 leading-relaxed mb-4">
              {article.description}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <a
            href={article.website_url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-musicRed hover:text-musicRedDark font-medium transition-colors"
          >
            Read Full Article
            <ExternalLink size={16} />
          </a>
        </div>
      </div>
    </div>
  );
}
